import { selectIsLoggedIn } from '@/features/oAuth/oAuthSlice';
import CookieModal from '@/shared/components/CookieModal/CookieModal';
import LoadingSpinner from '@/shared/components/LoadingSpinner/LoadingSpinner';
import LoginButton from '@/shared/components/LoginButton/LoginButton';
import PageWrapper from '@/shared/components/PageWrapper/PageWrapper';
import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styles from './Home.module.css';
import { useLocale } from '@/shared/helpers/i18n';
import { Redirect } from 'react-router';

type Props = {
  isLoading: boolean;
};

const Home: React.FC<Props> = ({ isLoading }) => {
  const { t, isGerman } = useLocale();
  const isLoggedIn = useSelector(selectIsLoggedIn);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isLoggedIn) {
    return <Redirect to={'/wallets'} />;
  }

  return (
    <PageWrapper name="home" noAuth={true} isHome={true} showFooter>
      <CookieModal />
      <section className={styles.wrapper} data-testid={'home'}>
        <IonGrid className={styles.grid}>
          <IonRow className={styles.emptyRow} />
          <IonRow>
            <IonCol>
              <h1 className={styles.title}>{t('hero.title')}</h1>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <h2 className={`${styles.subtitle}`}>{t('hero.subtitle')}</h2>
            </IonCol>
          </IonRow>
          <IonRow className={styles.mainContainer}>
            <IonCol size-md="5" size-xs="12" className={styles.textContainer}>
              <p className={styles.mainText}>{t('home.hero.paragraph')}</p>
              <LoginButton />
            </IonCol>
            <IonCol size-md="7" size-xs="12" className={styles.imgContainer}>
              <IonImg
                src={isGerman ? `assets/images/laptop-mockup_de-DE.png` : `assets/images/laptop-mockup_en-US.png`}
              />
            </IonCol>
          </IonRow>
          <IonRow className={styles.emptyLastRow} />
        </IonGrid>
      </section>
    </PageWrapper>
  );
};

export default withTranslation()(Home);
